module.exports = __webpack_public_path__ + "img/insurance.590952f0.svg";